import { render, staticRenderFns } from "./modelInfo.vue?vue&type=template&id=44e18f0c&scoped=true&"
import script from "./modelInfo.vue?vue&type=script&lang=js&"
export * from "./modelInfo.vue?vue&type=script&lang=js&"
import style0 from "./modelInfo.vue?vue&type=style&index=0&id=44e18f0c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e18f0c",
  null
  
)

export default component.exports